import { render, staticRenderFns } from "./FacilitiesDialog.vue?vue&type=template&id=4b2571ad&scoped=true&"
import script from "./FacilitiesDialog.vue?vue&type=script&lang=js&"
export * from "./FacilitiesDialog.vue?vue&type=script&lang=js&"
import style0 from "./FacilitiesDialog.vue?vue&type=style&index=0&id=4b2571ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2571ad",
  null
  
)

export default component.exports